import { render, staticRenderFns } from "./MealOptionSelection.vue?vue&type=template&id=a5c88a5c&scoped=true&"
import script from "./MealOptionSelection.vue?vue&type=script&lang=ts&"
export * from "./MealOptionSelection.vue?vue&type=script&lang=ts&"
import style0 from "./MealOptionSelection.vue?vue&type=style&index=0&id=a5c88a5c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c88a5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VTooltip})
